import React from 'react'
import { WrapperLayout } from '~/Components/WrapperLayout/WrapperLayout'
import AccordionTable from '../InvestmentHub/Components/Accordian';
import KnowledgeHubImg from "@assets/KPMG/KnowledgeHub.png";
import { Breadcrumb } from "antd";
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';


export const FAQ = () => {
    const navigate = useNavigate();

    const data = [
        {
            title: 'Measuring emissions and driver behaviour to design better roads and reduce CO2 emissions in the UAE',
            data: [
                {
                    description: 'Increase road safety by considering driver behaviour through the development of a new mobile application that collects the necessary data to analyse a driver’s reaction against the road safety guidelines',
                    sector: 'Transport',
                    location: 'UAE',
                    link: 'Measuring emissions and driver behaviour to design better roads and reduce CO2 emissions in the UAE - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean',
            data: [
                {
                    description: 'Pavimenta2 is a platform developed by the Inter-American Development Bank (IDB) to identify, measure, and quantify pavement failures and to validate transportation signage. By simply driving through the roadway network with a mounted cell phone or GoPro®, Pavimenta2 uses computer vision technology combined with artificial intelligence (AI) and deep learning to automate the measurement of quantities and locations of blurred lines, linear cracking, transversal cracking, crocodile cracking, rutting, and other failures and uploads the recorded video.  The tool also identifies roadway signage, classifies each sign, and decides if it is in good condition or may need maintenance.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'Using technology to adapt electricity distribution networks for cleaner, greener energy',
            data: [
                {
                    description: 'Future Grid is adapting electricity distribution networks for cleaner, greener energy by cleansing network data to improve GIS topology, reacting to network capacity constraints in real time, managing voltage and power quality issues, and detecting and managing the impacts of EVs and Solar PV. Rather than using a static model approach, Future Grid uses a dynamic process that uses data sensors at the grid edge to tell operators what is happening now.Available on the global SAP store, Future Grid’s innovative software has been successfully deployed in production to utilities across Australia and New Zealand.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'A novel approach to funding technology trials accelerates the water industry toward net zero',
            data: [
                {
                    description: 'The Trial Reservoir by Isle Utilities is a new and unique partnership model that brings technology users and innovators together. It provides loans for trial running costs, and conditions the loans such that a trial and purchase agreement between innovator and user must be in place prior to the trial, which guarantees implementation if the trial is successful. If the trial is not successful, then the loan is written off. To lower the number of trials required to bring an innovation to market, Isle Utilities organises joint marketing campaigns with both the technology vendor and the end-user after the successful conclusion of trials.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'A pilot of coated pavement surfaces to address the heat island effect in the UAE',
            data: [
                {
                    description: 'Solar reflection can influence pavement warming, and this warming has the potential to increase urban heat islands and contribute to global warming by warming the local air and transferring heat into the atmosphere.  The main objective of this research project is to assess the performance of the cool pavement technology (white coated pavement surfaces) in Zayed Educational Complex in Sharjah, United Arab Emirates. The cool pavement technology is considered a new reflective surface treatment that improves the reflectivity of the pavement. ',
                    sector: 'Social',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'Biomass power generation to promote green and low-carbon development in China',
            data: [
                {
                    description: 'The project will make full use of the local advantages of abundant agricultural biomass to produce power and heat, improve the heat-supply system for residents, provide thermal energy for industrial parks, and develop centralised heating systems –  all of which are conducive to saving energy, cutting pollution, and improving the environment.The project produces heat by burning biomass fuels in an incinerator, vaporising liquid water into steam by the boiler, and then generating electricity with water vapor by turbine generator.It includes the building of a circulation fluid- bed boiler with high temperature and pressure, equipped with the steam turbine generator unit, and reserving the expansion space for one boiler and one generator.This InfraTech is an urgent solution for solving the problems of environmental pollution and limited thermal energy.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'InfraTech to improve project management on a border connectivity project in China',
            data: [
                {
                    description: 'To improve economic and cultural connections between China and Vietnam, Chongzuo Urban Construction Investment and Development Co is enhancing the development of areas along the road that connects them. To support the project, they sought a fit-for-purpose management solution to deliver improved efficiency, quality, and safety, with a BIM model lightweight engine and the deployment of smart site technologies. \n The Digital Management and Control Platform, implemented by master technology partner PowerChina ZhongNan, is providing a solution that will deliver interoperability of all technologies selected throughout the project.The platform is designed to offer a convenient service for all parties involved in the engineering project and enable the management and control to be more transparent, efficient, and independent.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'Deployment of blockchain technologies to automate data and document flows in Italy',
            data: [
                {
                    description: 'The Trial Reservoir by Isle Utilities is a new and unique partnership model that brings technology users and innovators together. It provides loans for trial running costs, and conditions the loans such that a trial and purchase agreement between innovator and user must be in place prior to the trial, which guarantees implementation if the trial is successful. If the trial is not successful, then the loan is written off. To lower the number of trials required to bring an innovation to market, Isle Utilities organises joint marketing campaigns with both the technology vendor and the end-user after the successful conclusion of trials.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'High-efficiency water-saving irrigation in Chinasing technology to adapt electricity distribution networks for cleaner, greener energy',
            data: [
                {
                    description: 'The Trial Reservoir by Isle Utilities is a new and unique partnership model that brings technology users and innovators together. It provides loans for trial running costs, and conditions the loans such that a trial and purchase agreement between innovator and user must be in place prior to the trial, which guarantees implementation if the trial is successful. If the trial is not successful, then the loan is written off. To lower the number of trials required to bring an innovation to market, Isle Utilities organises joint marketing campaigns with both the technology vendor and the end-user after the successful conclusion of trials.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'Geothermal Energy from Canals and Mineshafts',
            data: [
                {
                    description: 'The Trial Reservoir by Isle Utilities is a new and unique partnership model that brings technology users and innovators together. It provides loans for trial running costs, and conditions the loans such that a trial and purchase agreement between innovator and user must be in place prior to the trial, which guarantees implementation if the trial is successful. If the trial is not successful, then the loan is written off. To lower the number of trials required to bring an innovation to market, Isle Utilities organises joint marketing campaigns with both the technology vendor and the end-user after the successful conclusion of trials.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },
        {
            title: 'Sensors to Mitigate Risk of Sewer Overflow',
            data: [
                {
                    description: 'The Trial Reservoir by Isle Utilities is a new and unique partnership model that brings technology users and innovators together. It provides loans for trial running costs, and conditions the loans such that a trial and purchase agreement between innovator and user must be in place prior to the trial, which guarantees implementation if the trial is successful. If the trial is not successful, then the loan is written off. To lower the number of trials required to bring an innovation to market, Isle Utilities organises joint marketing campaigns with both the technology vendor and the end-user after the successful conclusion of trials.',
                    sector: 'Transport',
                    location: 'Latin America and Caribbean',
                    link: 'AI and deep learning for identifying pavement failures in Latin American and the Caribbean - Infrastructure Technology (gihub.org)'
                },
            ],
        },

    ];
    const data01 = [
        {
            "name": "Group A",
            "value": 400,
            category: true
        },
        {
            "name": "Group B",
            "value": 300
        },

    ];
    return (
        <WrapperLayout
            title={"FAQ"}
            text={
                "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
            }
            image={KnowledgeHubImg}

        >
            <>
                <Breadcrumb style={{ marginBottom: 40 }}>
                    <Breadcrumb.Item>
                        <Icon
                            icon="ic:outline-home"
                            height="20"
                            onClick={() => navigate("/")}
                            style={{
                                margin: "auto",
                                //   color: styles.strawberry,
                                cursor: "pointer",
                            }}
                        />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a onClick={() => navigate("/knowledge-hub")}>FAQ</a>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </>
            <AccordionTable
                panels={data} isFaq={true}
            />
        </ WrapperLayout>
    )
}